import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { collection, query, where, getDocs, getFirestore } from "firebase/firestore";
import { FaBars, FaTimes, FaSignOutAlt } from "react-icons/fa";

const linksByRole = {
  superadmin: [
    ["Analytics", "/analytics"],
    ["Designs", "/design-management"],
    ["Users", "/user-management"],
    ["Partners", "/partner-manage"],
    ["Projects", "/recent-projects"],
    ["Blogs", "/blog-generation"],
    ["Landing Pages", "/landing-pages"],
  ],
  admin: [
    ["Analytics", "/analytics"],
    ["Users", "/user-management"],
    ["Blogs", "/blog-generation"],
    ["Landing Pages", "/landing-pages"],
  ],
};

function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const auth = getAuth();
  const db = getFirestore();
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);
      if (!currentUser) {
        setRole(null);
        return;
      }
      try {
        const adminQuery = query(
          collection(db, "admins"),
          where("email", "==", currentUser.email)
        );
        const snapshot = await getDocs(adminQuery);
        setRole(snapshot.empty ? null : snapshot.docs[0].data().role);
      } catch (error) {
        console.error("Error fetching admin role:", error);
        setRole(null);
      }
    });
    return unsubscribe;
  }, [auth, db]);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/login");
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  const navLinks = linksByRole[role] || [];

  return (
    <nav className="app-navbar position-sticky top-0 w-100">
      <div className="container-fluid px-3 px-xl-4">
        <div className="navbar-row">
          <Link to={user ? "/analytics" : "/login"} className="brand-link">
            <img src="/logo.png" alt="InteriorJi" className="brand-logo" />
            <span className="brand-credit">By Circuitwave Solution LLP</span>
          </Link>

          {user && (
            <button
              className="mobile-menu-button"
              type="button"
              onClick={() => setOpen((value) => !value)}
              aria-expanded={open}
              aria-label="Toggle navigation"
            >
              {open ? <FaTimes /> : <FaBars />}
            </button>
          )}

          {user ? (
            <div className={`nav-content ${open ? "is-open" : ""}`}>
              <div className="nav-links" aria-label="Admin navigation">
                {navLinks.map(([label, path]) => (
                  <Link
                    key={path}
                    to={path}
                    className={`admin-nav-link ${
                      location.pathname === path ? "active" : ""
                    }`}
                  >
                    {label}
                  </Link>
                ))}
              </div>
              <button onClick={handleLogout} className="logout-button" type="button">
                <FaSignOutAlt /> <span>Log out</span>
              </button>
            </div>
          ) : (
            <Link to="/login" className="gold-button nav-signin">
              Admin sign in
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
